import React, {ReactElement, ReactNode, useState} from 'react';
import { Button } from 'react-bootstrap';
import {confirm} from 'react-bootstrap-confirmation';
import { Variant } from 'react-bootstrap/esm/types';
import { ButtonSize } from './bootstrap';

interface ConfirmButtonProps {
    text: string;
    onConfirm: ()=>void;
    variant?: Variant
    size?: ButtonSize;
    children?: ReactNode
    className?: string;
}

export const ConfirmButton = (props: ConfirmButtonProps) => {
  
    const display = async () => {
    const result = await confirm(props.text);
    if(result) {
        props.onConfirm();
    }
  };
  
  return  <Button variant={props.variant} size={props.size} onClick={display} className={props.className}>{props.children}</Button>
}